import GameflowHelper from "../Helpers/GameflowHelper";
import { gameVM, game } from "../Game.jsx";

// TC Version
import background from "../assets/info-background.png";
import gameInfo from "../assets/info-information.png";
import howToPlay from "../assets/info-informationbutton.png";
import keyPoint from "../assets/info-palyinfobutton.png";
import next from "../assets/info-keypoint12button.png";
import startGame from "../assets/info-keypoint3button.png";
import playInfo from "../assets/info-palyinfo.png";
import keypoint1 from "../assets/info-keypoint1.png";
import keypoint2 from "../assets/info-keypoint2.png";

import wordsInAdvance from "../assets/game-foreword.png";
import gameBackground from "../assets/game-forewordbutton.png";

// EN Version
import backgroundEN from "../assets/EN/info-background.png";
import gameInfoEN from "../assets/EN/info-information.png";
import howToPlayEN from "../assets/EN/info-informationbutton.png";
import keyPointEN from "../assets/EN/info-palyinfobutton.png";
import nextEN from "../assets/EN/info-keypoint12button.png";
import startGameEN from "../assets/EN/info-keypoint3button.png";
import playInfoEN from "../assets/EN/info-palyinfo.png";
import keypoint1EN from "../assets/EN/info-keypoint1.png";
import keypoint2EN from "../assets/EN/info-keypoint2.png";

import wordsInAdvanceEN from "../assets/EN/game-foreword.png";
import gameBackgroundEN from "../assets/EN/game-forewordbutton.png";

// SC Version
import backgroundSC from "../assets/SC/info-background.png";
import gameInfoSC from "../assets/SC/info-information.png";
import howToPlaySC from "../assets/SC/info-informationbutton.png";
import keyPointSC from "../assets/SC/info-palyinfobutton.png";
import nextSC from "../assets/SC/info-keypoint12button.png";
import startGameSC from "../assets/SC/info-keypoint3button.png";
import playInfoSC from "../assets/SC/info-palyinfo.png";
import keypoint1SC from "../assets/SC/info-keypoint1.png";
import keypoint2SC from "../assets/SC/info-keypoint2.png";

import wordsInAdvanceSC from "../assets/SC/game-foreword.png";
import gameBackgroundSC from "../assets/SC/game-forewordbutton.png";

export default class Scene2ViewModel {
  currentScene;
  constructor(scene2) {
    this.currentScene = scene2;
  }

  preloadAssets() {
    if (gameVM.language == null) {
      this.removeTextures();
      this.currentScene.load.image("background", background, true);
      this.currentScene.load.image("gameInfo", gameInfo, true);
      this.currentScene.load.image("howToPlay", howToPlay, true);
      this.currentScene.load.image("keyPoint", keyPoint, true);
      this.currentScene.load.image("next", next, true);
      this.currentScene.load.image("startGame", startGame, true);
      this.currentScene.load.image("playInfo", playInfo, true);
      this.currentScene.load.image("keypoint1", keypoint1, true);
      this.currentScene.load.image("keypoint2", keypoint2, true);
      this.currentScene.load.image("wordsInAdvance", wordsInAdvance, true);
      this.currentScene.load.image("gameBackground", gameBackground, true);
    } else if (gameVM.language == "EN") {
      this.removeTextures();
      this.currentScene.load.image("background", backgroundEN, true);
      this.currentScene.load.image("gameInfo", gameInfoEN, true);
      this.currentScene.load.image("howToPlay", howToPlayEN, true);
      this.currentScene.load.image("keyPoint", keyPointEN, true);
      this.currentScene.load.image("next", nextEN, true);
      this.currentScene.load.image("startGame", startGameEN, true);
      this.currentScene.load.image("playInfo", playInfoEN, true);
      this.currentScene.load.image("keypoint1", keypoint1EN, true);
      this.currentScene.load.image("keypoint2", keypoint2EN, true);
      this.currentScene.load.image("wordsInAdvance", wordsInAdvanceEN, true);
      this.currentScene.load.image("gameBackground", gameBackgroundEN, true);
    } else if (gameVM.language == "SC") {
      this.removeTextures();
      this.currentScene.load.image("background", backgroundSC, true);
      this.currentScene.load.image("gameInfo", gameInfoSC, true);
      this.currentScene.load.image("howToPlay", howToPlaySC, true);
      this.currentScene.load.image("keyPoint", keyPointSC, true);
      this.currentScene.load.image("next", nextSC, true);
      this.currentScene.load.image("startGame", startGameSC, true);
      this.currentScene.load.image("playInfo", playInfoSC, true);
      this.currentScene.load.image("keypoint1", keypoint1SC, true);
      this.currentScene.load.image("keypoint2", keypoint2SC, true);
      this.currentScene.load.image("wordsInAdvance", wordsInAdvanceSC, true);
      this.currentScene.load.image("gameBackground", gameBackgroundSC, true);
    }
  }

  removeTextures() {
    const imgKeys = [
      "background",
      "gameInfo",
      "howToPlay",
      "keyPoint",
      "next",
      "startGame",
      "playInfo",
      "keypoint1",
      "keypoint2",
      "wordsInAdvance",
      "gameBackground"
    ];

    for (let key of imgKeys) {
      this.currentScene.textures.remove(key);
    }
  }

  loadImgAssets() {}

  addBackground() {
    this.currentScene.add.image(0, 0, "background").setOrigin(0, 0);
  }

  addBackgroundHover(colorHex, opacity) {
    if (this.currentScene.graphics) {
      this.currentScene.graphics.destroy();
    }
    this.currentScene.graphics = this.currentScene.add.graphics({
      fillStyle: {
        color: colorHex
      }
    });
    this.currentScene.graphics.fillRect(0, 0, 1920, 1080);
    this.currentScene.tweens.add({
      targets: this.currentScene.graphics,
      alpha: {
        from: 0,
        to: opacity
      },
      duration: 500
    });
  }

  fadeIn(obj, finalOpacity, duration) {
    this.currentScene.tweens.add({
      targets: obj,
      alpha: {
        from: 0,
        to: finalOpacity
      },
      duration: duration
    });
  }

  fadeout(obj, duration) {
    this.currentScene.tweens.add({
      targets: obj,
      alpha: {
        from: obj.alpha,
        to: 0
      },
      duration: duration
    });
  }
}
